<div class="wrapper fadeInDown">
  <div id="formContent">
    <div style="display: inline;">
      <img style="max-width: 45%" src="../assets/logos/logo-celonmedia.jpg" alt="logo-celonmedia.jpg">
    </div>
    <!-- Login Form -->
    <form (ngSubmit)="onSubmit()">
      <input type="email" id="email" #email="ngModel" [(ngModel)]="form.email" class="fadeIn second" name="email" placeholder="e-mail">
      <input type="password" id="password" #password="ngModel" [(ngModel)]="form.password" class="fadeIn third" name="password" placeholder="password">
      <input [disabled]="loading" type="submit" class="fadeIn fourth" value="Log In">
    </form>
    <!-- Remind Passowrd -->
    <!--div id="formFooter">
      <a class="underlineHover" href="#">Forgot Password?</a>
    </div-->
  </div>
</div>
